// extracted by mini-css-extract-plugin
var _1 = "OtherSettings_delimiter__9ccf3";
var _2 = "OtherSettings_label__1f15e";
var _3 = "OtherSettings_list__4208a";
var _4 = "OtherSettings_titleList__91c4e";
export { _1 as "delimiter", _2 as "label", _3 as "list", _4 as "titleList" }
